import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicationSettings } from 'projects/lib_config/src/public-api';
import { UserService } from 'projects/lib_util/src/lib/services/user.service';
import { Observable, ReplaySubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { PublicCookieHelper } from '../helpers/public-cookie.helper';
import { AuthenticatedUser } from '../models/authenticated-user.model';
import { UserRolesAndPermissions } from '../models/roles-and-permissions.model';
import { OidcSecurityService } from './oidc-security.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private _user$: ReplaySubject<AuthenticatedUser>;
  private _rolesAndPermissions$: ReplaySubject<UserRolesAndPermissions>;

  constructor(private http: HttpClient,
    private oidcSecurityService: OidcSecurityService,
    private userService: UserService,
    private settings: ApplicationSettings) { }

  getAuthenticadedUserObservable() {
    if (!this._user$) {
      this._user$ = new ReplaySubject<AuthenticatedUser>(1);
      this.oidcSecurityService.getUserInfo().subscribe(result => {
        this._user$.next(new AuthenticatedUser(result));
        this._user$.complete();
      }, error => {
        this._user$.error(error);
        this._user$.complete();
      });
    }
    
    return this._user$.asObservable();
  }

  getRolesAndPermissionsObservable() {
    if (!this._rolesAndPermissions$) {
      this._rolesAndPermissions$ = new ReplaySubject<UserRolesAndPermissions>(1);
      this.getAuthenticadedUserObservable().subscribe(x => {
        if(x.email){
          this.userService.getUserRolesWithPermissions(x.email).subscribe(y => {
            var permissions: UserRolesAndPermissions;
  
            if (!x) permissions = null;
            else permissions = new UserRolesAndPermissions(y); // instantiating as a TS object so methods on the class can be used
  
            this._rolesAndPermissions$.next(permissions);
  
            if (this.settings.production) this._rolesAndPermissions$.complete();
          });
        }
      })
    }
    return this._rolesAndPermissions$.asObservable();
  }

  async getLatestRolesAndPermissionsAsync() {
    return await this.getRolesAndPermissionsObservable().pipe(take(1)).toPromise();
  }

  async tempRemoveApplicationPermissions() {
    if (!this.settings.production) {
      var permissions = await this.getLatestRolesAndPermissionsAsync();
      permissions.applicationPermissions.permissions = [];
      permissions.applicationPermissions.roles = ["User"];
      this._rolesAndPermissions$.next(permissions);
      this._rolesAndPermissions$.complete();
    }
  }

  requestAccessToPortal() {
    return new Observable(subscriber => {
      this.getAuthenticadedUserObservable().subscribe(x => {
        this.http.post('dummy', x.email).subscribe(y => {
          subscriber.next();
          subscriber.complete();
        });
      });
    })
  }

  login() {
    this.oidcSecurityService.authorize();
  }

  logoff() {
    PublicCookieHelper.deletePublicCookie();
    this.oidcSecurityService.logOff();
  }
}
